import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import Button from 'srcReact/components/common2/Button'
import { workplaceActions } from 'srcReact/WorkplacePage'
import { commonActions } from 'srcReact/components'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { redirectToPage } from 'srcReact/helpers/history'

const WorkplaceSidebar = ({ workplaceId, handleSelectedWorkplace }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative, isDesktop },
    workplaceSettings: { workplace_list }
  } = useSelector((state) => state)
  const [organizationId] = useState(getCurrentOrgId())

  const handleNewWorkplace = () => {
    dispatch(
      workplaceActions.canAccess(
        'page-create-workplace',
        organizationId,
        null,
        () => redirectToPage(`/0/create-workplace?organization_id=${organizationId}`, isNative),
        () => dispatch(commonActions.openPopin('billing-workplace-popins'))
      )
    )
  }

  return (
    <div className={styles.workplaceSidebarWrapper}>
      {isDesktop && (
        <div className={styles.goBack}>
          <BackNavigation className={styles.backNavigation} />
        </div>
      )}

      <h2 className={styles.heading}>{t('nav.workplaces')}</h2>

      <div className={`${styles.workplaceList} ${workplace_list?.length > 8 && styles.showMore}`}>
        {workplace_list?.length > 0 &&
          workplace_list?.map((w, idx, arr) => (
            <React.Fragment key={idx}>
              <Button
                text={w?.name}
                customStyle={`${styles.button} ${w?.id == workplaceId ? styles[w?.color] : styles.hasNotActive}`}
                handleClick={() => handleSelectedWorkplace(w?.id)}
              />
              {idx === arr.length - 1 && (
                <Button
                  text={t('workplaceSettings.leadershipTeam.addMembers')}
                  style='dashed'
                  customStyle={styles.button}
                  handleClick={handleNewWorkplace}
                />
              )}
            </React.Fragment>
          ))}
      </div>
    </div>
  )
}

export default WorkplaceSidebar
